import ThemeReducer from "./reducers/ThemeReducer"
import shapesFeatures from "./features/shapes.features"
import titlesFeatures from "./features/titles.features"
 
import originFeatures from "./features/origin.features"
import productFeatures from "./features/product.features"
import customerFeatures from "./features/customer.features"
import bankFeatures from "./features/bank.features"
import suppliersFeatures from "./features/suppliers.features"
import alertBoxFeatures from "./features/alertbox.features"
import salesFeatures from "./features/sales.features"
import tripFeatures from "./features/trip.features"
import brokerFeatures from "./features/broker.features"
import userFeatures from "./features/user.features"
import storageBoxFeatures from "./features/storageBox.features"


import { combineReducers } from "redux"

const rootReducer = combineReducers({
    productReducer :productFeatures,
    ThemeReducer,
    shapesReducer :shapesFeatures,
    titlesReducer :titlesFeatures,
     
    originReducer :originFeatures,
    customerReducer :customerFeatures,
    tripReducer :tripFeatures,
    suppliersReducer :suppliersFeatures,
    salesReducer :salesFeatures,
    alertBoxReducer :alertBoxFeatures,
    brokerReducer :brokerFeatures,
    bankReducer :bankFeatures,
    userReducer :userFeatures,
    storageBoxReducer :storageBoxFeatures,
})

export default rootReducer